import VueRouter, { RouteConfig } from "vue-router";
import store from "@/store";
import Vue from "vue";
import { Roles } from "@/models/user/roles";
import { ProductType } from "@/models/products/product";

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
  {
    path: "*",
    name: "NotFound",
    component: () => import("../views/landing/NotFound.vue")
  },
  {
    path: "/resubmit",
    alias: ["/expired"],
    name: "Resubmit",
    component: () => import("../views/landing/FormExpired.vue")
  },
  {
    path: "/error",
    name: "Error",
    component: () => import("../views/landing/Error.vue"),
  },
  {
    path: "/customers",
    name: "Customers",
    component: () => import("../views/customers/CustomerList.vue")
  },
  {
    path: "/customers/orders/:id",
    name: "CustomerOrders",
    component: () => import("../views/customers/CustomerOrders.vue")
  },
  {
    path: "/quickship",
    name: "Quickship",
    component: () => import("../views/items/QuickshipList.vue")
  },
  {
    path: "/checkout",
    name: "Checkout",
    component: () => import("../views/orders/Checkout.vue")
  },
  {
    path: "/checkout/review",
    name: "OrderReview",
    component: () => import("../views/orders/OrderReview.vue"),
    props: route => ({
      props: route.params
    })
  },
  {
    path: "/checkout/submitted",
    name: "Submitted",
    component: () => import("../views/orders/Submitted.vue")
  },
  {
    path: "/cart",
    name: "Cart",
    component: () => import("../views/orders/Cart.vue")
  },
  {
    path: "/cart/:id",
    name: "SavedCart",
    component: () => import("../views/orders/Cart.vue")
  },
  {
    path: "/profile/my-orders",
    name: "MyOrders",
    component: () => import("../views/orders/OrderList.vue")
  },
  {
    path: `/items/:product(${ProductType.Base}|${ProductType.Chair}|${ProductType.Umbrella})`,
    name: "ItemCustomization",
    component: () => import("@/views/items/ItemCustomization.vue")
  },
  {
    path: "/",
    alias: ["/collections/umbrella"],
    component: () => import("@/views/collections/CollectionMenu.vue"),
    props: route => ({
      props: route.params
    }),
    children: [
      {
        path: `/collections/:product(${ProductType.Accessory}|${ProductType.Base}|${ProductType.Chair}|${ProductType.Umbrella})`,
        component: () => import("@/views/collections/CollectionMenu.vue"),
        props: route => ({
          props: route.params
        })
      }
    ]
  },

  {
    path: "/login",
    beforeEnter(to, from, next) {
      // Put the full page URL including the protocol http(s) below
      window.location.replace(
        `${process.env.VUE_APP_LOGIN_URL}?returnURL=${process.env.VUE_APP_URL}/`
      );
      // window.location.replace('http://localhost:8080?returnURL=http://localhost:8081/designer')
    }
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;

// router.beforeEach((to, from, next) => {
//   //@ts-ignore
//   const isLoggedIn = store.state.global.isLoggedIn;
//   //@ts-ignore
//   const userRole = store.state.global.userRole;

//   if (to.matched.some(record => record.meta.requiresVerification)) {
//     // this route requires auth, check if logged in
//     // if not, redirect
//     if (!isLoggedIn || userRole === Roles.Unverified) {
//       next({
//         path: "/designer"
//       });
//     } else {
//       next();
//     }
//   } else if (to.matched.some(record => record.meta.requiresAuth)) {
//     // this route requires auth, check if logged in
//     // if not, redirect
//     if (!isLoggedIn) {
//       next({
//         path: "/designer"
//       });
//       next();
//     } else {
//       next();
//     }
//   } else {
//     next(); // make sure to always call next()!
//   }
// });
